export default __webpack_public_path__ + "static/media/060-bank-check.79bffb6b.svg";